var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerCard/index.tsx";
import React, { useCallback, useMemo } from 'react';
import { Divider, HStack, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconLinkArrow12x24 } from '@adc/parallax-icons';
import { Link } from 'Components/utility';
import { ANALYTICS_ACTIONS, ANALYTICS_EVENTS, ANALYTICS_MODULE_TYPES } from 'Constants/analytics';
import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PartnerCard = ({
  partnerConnections,
  partnerInvitations,
  availableCommercialAPIPartners
}) => {
  const hasCommercialApiPartnersAvailable = Boolean(availableCommercialAPIPartners?.length);
  // TODO: adjust this with correct API field
  const hasPumpPartnerAvailable = Boolean(false);
  const sortedConnections = useMemo(() => {
    if (!partnerConnections?.length) {
      return [];
    }
    return [...partnerConnections].sort((a, b) => b.consent.created - a.consent.created);
  }, [partnerConnections]);
  const sortedInvitations = useMemo(() => {
    if (!partnerInvitations?.length) {
      return [];
    }
    return [...partnerInvitations].sort((a, b) => b.invitation.created - a.invitation.created);
  }, [partnerInvitations]);
  const handleAddConnection = useCallback(() => {
    if (hasPumpPartnerAvailable && hasCommercialApiPartnersAvailable) {
      return mediator.publish('router:navigate', {
        url: '/entry-add-connection',
        data: {
          availableCommercialAPIPartners
        }
      });
    }
    mediator.publish('router:navigate', {
      url: '/partner-add-connection',
      data: {
        availableCommercialAPIPartners
      }
    });
  }, [availableCommercialAPIPartners, hasCommercialApiPartnersAvailable, hasPumpPartnerAvailable]);
  const handleOpenConnection = useCallback(partnerConnection => {
    mediator.publish('router:navigate', {
      url: '/partner-connection',
      data: {
        partnerConnection
      }
    });
    analyticsManager.track(ANALYTICS_EVENTS.CONNECTION_MANAGED, {
      module: ANALYTICS_MODULE_TYPES.CONAPPS_MODULE,
      action: ANALYTICS_ACTIONS.ACCESS,
      partnerName: partnerConnection.partner.name,
      connectionStatus: 'connected'
    });
  }, []);
  const handleOpenInvitation = useCallback(partnerInvitation => {
    mediator.publish('router:navigate', {
      url: '/partner-confirm-connection',
      data: {
        partnerConnection: {
          partner: partnerInvitation.partner,
          consent: {
            ...partnerInvitation.invitation
          }
        }
      }
    });
    analyticsManager.track(ANALYTICS_EVENTS.CONNECTION_MANAGED, {
      module: ANALYTICS_MODULE_TYPES.CONAPPS_MODULE,
      action: ANALYTICS_ACTIONS.ACCESS,
      partnerName: partnerInvitation.partner.name,
      connectionStatus: 'pending'
    });
  }, []);
  const renderEmptyState = useCallback(() => /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "Partner.no-connections",
    fontSize: "$bodyBase.default",
    color: "$text.100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.otherConnections.bodyText')), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Link, {
    testID: "Partner.addConnection-btn",
    onPress: handleAddConnection,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.otherConnections.links.addConnectionBtn.label'))), [handleAddConnection]);
  const renderList = () => /*#__PURE__*/React.createElement(React.Fragment, null, sortedInvitations.map((partnerInvitation, index) => {
    const isLast = index === sortedInvitations.length - 1;
    return /*#__PURE__*/React.createElement(VStack, {
      key: partnerInvitation.partner.id,
      onPress: () => handleOpenInvitation(partnerInvitation),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 115,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "PartnerInvitation.pending-label",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 15
      }
    }, i18n.t('Connections.content.otherConnections.secondaryText')), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "PartnerInvitation.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 129,
        columnNumber: 15
      }
    })), /*#__PURE__*/React.createElement(Text, {
      color: "$text.60",
      fontSize: "$bodySmall.default",
      fontWeight: "$bodySmall.default",
      testID: "PartnerInvitation.partnerName",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135,
        columnNumber: 13
      }
    }, partnerInvitation.partner.name), !isLast && /*#__PURE__*/React.createElement(Divider, {
      marginVertical: "$2",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 143,
        columnNumber: 25
      }
    }));
  }), sortedConnections.length > 0 && sortedInvitations.length > 0 && /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$2",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 9
    }
  }), sortedConnections.map((partnerConnection, index) => {
    const isLast = index === sortedConnections.length - 1;
    return /*#__PURE__*/React.createElement(VStack, {
      key: partnerConnection.partner.id,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      paddingVertical: !isLast ? '$2' : '$0',
      onPress: () => handleOpenConnection(partnerConnection),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "Partner.name",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      numberOfLines: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 160,
        columnNumber: 15
      }
    }, partnerConnection.partner.name), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "Partner.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 170,
        columnNumber: 15
      }
    })), !isLast && /*#__PURE__*/React.createElement(Divider, {
      marginVertical: "$2",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 176,
        columnNumber: 25
      }
    }));
  }), hasCommercialApiPartnersAvailable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Link, {
    testID: "Partner.addConnection-btn",
    onPress: handleAddConnection,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.otherConnections.links.addConnectionBtn.label'))));
  if (!partnerConnections?.length && !hasCommercialApiPartnersAvailable) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 203,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "Partner.title",
    fontWeight: "$h4.strong",
    fontSize: "$h4.medium",
    color: "$text.100",
    marginBottom: "$5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 204,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.otherConnections.primaryText')), sortedConnections.length === 0 && sortedInvitations.length === 0 ? renderEmptyState() : renderList()));
};
export default PartnerCard;